if(!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    constructor() {
      super()
      this.thumbnails = this.querySelectorAll('[data-thumbnail-id]')
      this.featured = this.querySelectorAll('[data-featured-id]')
      this.changeMedia()
    }
    changeMedia() {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.updateActive.bind(this))
      })
    }
    updateActive(e) {
      pauseAllMedia()
      const currentMedia = e.target
      currentMedia.classList.add('current')

      this.thumbnails.forEach((thumbnail) => {
        if (thumbnail !== currentMedia) {
          thumbnail.classList.remove('current')
        }
      })
      this.featured.forEach((media) => {
        if (media.dataset.featuredId === currentMedia.dataset.thumbnailId) {
          media.classList.remove('hidden')
        } else {
          media.classList.add('hidden')
        }
      })
    }
  }
  customElements.define('product-gallery', ProductGallery)
}